import './index.scss'

import { initApp, setActiveNav } from 'app/js/app'

setActiveNav()
$(() => {
  initApp()
})



// WEBPACK FOOTER //
// ./src/finops/index.js